import ParentStyled from '@/modules/LogsManagement/style';
import { Link as LinkLi } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import EditSharpIcon from '@material-ui/icons/EditSharp';
import HistoryIcon from '@material-ui/icons/History';
import { pageUrls } from 'globalconfig/constants/keys';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import { UI_DATE_LOWER_FORMAT, UI_LOGBOOK_DATE } from 'globalconfig/constants/static';
import { getNewObject, hasRestrictedRole, isDriver, loadPageConfig, loadStyle } from 'globalutils/fmUtils';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { lazy, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { checkServiceProvider } from './serviceProviderConfig';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Tab = lazy(() => import(`globalcomponents/UI/Tab/${layout}`));
const config = loadPageConfig();
const Component = lazy(() => import(`@/${config.logsList[1].name}`));
const SvgIcon = lazy(() => import(`globalcomponents/SvgIcon/${layout}`));
let Styled = loadStyle(ParentStyled, 'modules/LogsManagement');

const Index = (parentProps) => {
  const SERVICE_PROVIDER = window.$environment.SERVICE_PROVIDER;
  const { manageLogList, fetchLogList, getFilters } = parentProps;
  const [pagination, setPagination] = useState(false);
  const history = useHistory();
  const i18n = useTranslation();
  const theme = useTheme();
  const commonParentProps = { history, i18n, Styled, theme };
  const [selectedIndex, setSelectedIndex] = useState(0);

  const setSelectedIndexfn = (index) => {
    let rowLen = 39;
    let wl = 74;
    const tenantVal = checkServiceProvider('setSelectedIndexfn', SERVICE_PROVIDER, false);
    if (tenantVal) {
      rowLen = tenantVal.rowLen;
      wl = tenantVal.wl;
    } else if (window.$environment.APP_LAYOUT === 'NewUi') {
      rowLen = 40;
      wl = 82;
    }
    setSelectedIndex(wl + rowLen * index);
  };

  useEffect(() => {
    fetchLogList({ apiId: 'fetchLoglistApiId', realTimeLogs: true });
    getFilters({ apiId: 'fetchFilters' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (document.getElementById('list1')) {
      const isSelected = document.getElementById('list1')?.className.includes('Mui-selected');
      document.getElementById('list1').className = !isSelected
        ? document.getElementById('list1').className + ' Mui-selected'
        : document.getElementById('list1').className;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [document.getElementById('list1')]);

  return (
    <RenderComponent
      {...config.logsList[1]}
      parentProps={parentProps}
      commonParentProps={commonParentProps}
      history={history}
      i18n={i18n}
      list={manageLogList}
      selectedIndex={selectedIndex}
      setSelectedIndexfn={setSelectedIndexfn}
      pagination={pagination}
      setPagination={setPagination}
    />
  );
};

const RenderComponent = ({
  name,
  props,
  commonProps,
  title,
  parentProps,
  commonParentProps,
  history,
  i18n,
  verticalTab,
  selectedIndex,
  setSelectedIndexfn,
  pagination,
  setPagination,
  ...rest
}) => {
  const SERVICE_PROVIDER = window.$environment.SERVICE_PROVIDER;
  const handleChange = (event, newValue, fromSubTab) => {
    if (fromSubTab) history.push(subTabValues[newValue].url);
    else history.push(tabValues[newValue].url);
  };
  const [isToolsClicked, setIsToolsClicked] = useState(false);

  const actions = hasRestrictedRole(['ADMIN'])
    ? []
    : window.$environment.CURRENT_LAYOUT === 'SpireonNew'
    ? [
        {
          icon: (row, index) => {
            let day = moment(new Date(row.date)).format(UI_LOGBOOK_DATE);
            return (
              <LinkLi
                component={Link}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                to={`${pageUrls.logBook.replace(':id', row.idPub)}?driverId=${row.driverId}&logDay=${day}`}
              >
                <SvgIcon value={mediaUrls.bookSolid} className="logbookIcon" />
              </LinkLi>
            );
          },
        },
        {
          icon: (row, index) => {
            return (
              <LinkLi
                style={{ visibility: 'hidden' }}
                component={Link}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                to={pageUrls.logsEdit.replace(':id', row.idPub)}
              >
                <EditSharpIcon className="historyIcon" />
              </LinkLi>
            );
          },
        },

        {
          icon: (row, index) => {
            return (
              <LinkLi
                style={{ visibility: 'hidden' }}
                component={Link}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                to={pageUrls.logsHistory.replace(':id', row.idPub)}
              >
                <HistoryIcon className="historyIcon" />
              </LinkLi>
            );
          },
        },
      ]
    : layout !== 'Clutch'
    ? [
        {
          icon: (row, index) => {
            return (
              <Icon
                src={mediaUrls?.toolsIcon}
                onClick={() => {
                  setIsToolsClicked(true);
                  parentProps.setSelectedManageLogItem({ index, row });
                  setSelectedIndexfn(index);
                }}
              />
            );
          },
        },
      ]
    : [];

  let newProps = props?.length ? getNewObject(parentProps, props) : {};
  newProps = {
    ...newProps,
    ...(commonProps?.length ? getNewObject(commonParentProps, commonProps) : {}),
    ...rest,
  };

  const selectedRow = (row) => {
    let day = moment(new Date(row.date)).format(UI_LOGBOOK_DATE);
    !hasRestrictedRole(['ADMIN']) &&
      history.push(`${pageUrls.logBook.replace(':id', row.idPub)}?driverId=${row.driverId}&logDay=${day}`);
  };

  const subTabValues = [
    {
      name: i18n.t('logs.manageLogsHeaderSigned'),
      value: null,
      url: pageUrls.logsList,
    },
    {
      name: i18n.t('logs.manageLogsHeaderUnSigned'),
      value: (
        <Component
          selectedRow={(row, id) => selectedRow(row)}
          isDriverLogs={false}
          {...newProps}
          isRealTimeLogs
          actions={actions}
          isToolsClicked={isToolsClicked}
          setIsToolsClicked={setIsToolsClicked}
          selectedIndex={selectedIndex}
          pagination={pagination}
          setPagination={setPagination}
          fields={[
            {
              type: 'text',
              value: '',
              field: 'driver_name',
              placeholder: i18n.t('common.driver'),
              label: i18n.t('common.driver'),
            },
            {
              type: 'date',
              value: '',
              field: 'dateFrom',
              placeholder: UI_DATE_LOWER_FORMAT,
              label: i18n.t('common.dateFrom'),
              isTimeNeeded: false,
              isClearable: true,
            },
            {
              type: 'date',
              value: '',
              field: 'dateTo',
              placeholder: UI_DATE_LOWER_FORMAT,
              label: i18n.t('common.dateTo'),
              isTimeNeeded: false,
              minValue: 'dateFrom',
            },
          ]}
        />
      ),
      url: pageUrls.realTimeLogsList,
    },
  ];

  const tabValues = [
    {
      name: i18n.t('logs.manageLogsHeader'),
      value: (
        <>
          <Tab
            data={subTabValues}
            className={checkServiceProvider('manageLogsHeader_className', SERVICE_PROVIDER, false)}
            currentTab={1}
            onChange={(event, newValue) => handleChange(event, newValue, true)}
            vertical={checkServiceProvider('manageLogsHeader_style', SERVICE_PROVIDER, false) ? verticalTab : false}
          />
        </>
      ),
      url: pageUrls.logsList,
    },
    ...(!isDriver()
      ? [
          {
            name: i18n.t('logs.undefinedDriverHeader'),
            value: null,
            url: pageUrls.logsUdList,
          },
          ...(checkServiceProvider('driverTabs', SERVICE_PROVIDER, false) || []),
        ]
      : []),
    ...(checkServiceProvider('tenantTabs', SERVICE_PROVIDER, false) || []),
  ];

  return (
    <Styled.Content>
      <div className="goBack">
        <SvgIcon value={mediaUrls.pageBackButton} onClick={() => history.goBack()} />
      </div>
      <Tab data={tabValues} className="logwrapper" currentTab={0} onChange={handleChange} vertical={verticalTab} />
    </Styled.Content>
  );
};

const mapState = (state) => {
  return {
    apiStatus: state.asyncRequests,
    manageLogList: state.manageLogList,
    filters: state.filters,
  };
};
const mapDispatch = (dispatch) => {
  return {
    fetchLogList: (data) => dispatch.manageLogList.fetchData(data),
    filterSuccess: (data) => dispatch.manageLogList.filterSuccess(data),
    setSelectedManageLogItem: (data) => dispatch.manageLogList.setSelectedItem(data),
    handleLogBookStatus: (data) => dispatch.logBookStatus.handleLogBookStatus(data),
    clearApiStatus: () => dispatch.asyncRequests.clearApiStatus(),
    getFilters: (data) => dispatch.filters.fetchData(data),
    viewReport: (data) => dispatch.viewReport.viewReportDocument(data),
  };
};

export default connect(mapState, mapDispatch)(Index);
Index.defaultTypes = {};
Index.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
  manageLogList: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  filterSuccess: PropTypes.func.isRequired,
  handleLogBookStatus: PropTypes.func.isRequired,
  clearApiStatus: PropTypes.func.isRequired,
  setSelectedManageLogItem: PropTypes.func.isRequired,
  fetchUdLogList: PropTypes.func.isRequired,
  udFilterSuccess: PropTypes.func.isRequired,
  fetchUnAssignedEntries: PropTypes.func.isRequired,
  unAssignedEntries: PropTypes.object.isRequired,
  saveUnAssignedEntries: PropTypes.func.isRequired,
  setUdAssignEntryList: PropTypes.func.isRequired,
  clearUdAssignEntryListById: PropTypes.func.isRequired,
};
